import apiClient from './api';

export interface AuthResponse {
  access_token: string;
  user: {
    id: string;
    email: string;
    name: string;
    role: 'ADMIN' | 'GESTIONNAIRE' | 'INVENTORISTE' | 'LECTEUR';
    createdAt?: string;
    lastLogin?: string;
    themes?: string[];
  };
}

export const authService = {
  async login(email: string, password?: string): Promise<AuthResponse> {
    const response = await apiClient.post('/auth/login', { email, password });
    const { access_token, token, user } = response.data;
    
    // Stocker le token (utiliser access_token ou token selon ce qui est disponible)
    const authToken = access_token || token;
    localStorage.setItem('auth_token', authToken);
    
    return { access_token: authToken, user };
  },

  async getProfile(): Promise<any> {
    const response = await apiClient.get('/auth/profile');
    return response.data;
  },

  async updateProfile(profileData: any): Promise<any> {
    const response = await apiClient.patch('/auth/profile', profileData);
    return response.data;
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await apiClient.post('/auth/change-password', {
      currentPassword,
      newPassword
    });
  },

  async createUser(userData: any): Promise<any> {
    const response = await apiClient.post('/auth/users', userData);
    return response.data;
  },

  async getUsers(): Promise<any[]> {
    const response = await apiClient.get('/auth/users');
    return response.data;
  },

  async updateUser(userId: string, userData: any): Promise<any> {
    const response = await apiClient.patch(`/auth/users/${userId}`, userData);
    return response.data;
  },

  async deleteUser(userId: string): Promise<void> {
    await apiClient.delete(`/auth/users/${userId}`);
  },

  logout(): void {
    localStorage.removeItem('auth_token');
  },

  getToken(): string | null {
    return localStorage.getItem('auth_token');
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  }
};

